import { render, staticRenderFns } from "./CustomMetric.vue?vue&type=template&id=1fd06ab2&scoped=true&"
import script from "./CustomMetric.vue?vue&type=script&lang=js&"
export * from "./CustomMetric.vue?vue&type=script&lang=js&"
import style0 from "./CustomMetric.vue?vue&type=style&index=0&id=1fd06ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd06ab2",
  null
  
)

export default component.exports